/**
 * Driver Quantities (FSD 2.2.6) — the menu-level driver-quantity report.
 *
 * Spread into the module's route table by the wave's INT packet. The per-driver
 * capture grid stays at `/cost/drivers/:id/quantities` (`COST_ROUTES`); this is
 * the screen with a driver picker and a period trend that the Finance menu item
 * opens, which is why it is a route of its own and not that grid without an id.
 */

import type { RouteRecordRaw } from 'vue-router'

import { COST_PERMISSIONS } from '@/modules/cost/permissions'

export const COST_QUANTITIES_ROUTES: RouteRecordRaw[] = [
  {
    path: '/cost/quantities',
    name: 'cost-quantities',
    component: () => import('@/modules/cost/quantities/DriverQuantityReportView.vue'),
    meta: { titleKey: 'cost.routeTitles.quantities', permission: COST_PERMISSIONS.driverRead },
  },
]
